export class Storage {
    storageList = {}

    constructor() {
        this.localStorage = window.localStorage
    }

    set(key, value) {
        let _value = value
        if (typeof value !== 'string') {
            _value = JSON.stringify(value)
        }
        this.localStorage.setItem(key, _value)
        return {
            key, value: _value,
        }
    }

    get(key) {
        this.storageList[key] = JSON.parse(
            this.localStorage.getItem(key)) || ''
        return {
            key,
            value: this.storageList[key],
        }
    }

    remove(key) {
        this.localStorage.removeItem(key)
        delete this.storageList[key]
    }

    clear() {
        this.localStorage.clear()
        this.storageList = {}
    }
}

const LOCAL_ACCOUNTS_KEY = 'LOCAL_ACCOUNTS'
const LOCAL_ACCOUNT_DATA_KEY = 'LOCAL_ACCOUNT_DATA'
const LOCAL_APP_CONFIG = 'LOCAL_APP_CONFIG'
const LOCAL_LAST_LOGIN_ACCOUNT = 'LOCAL_LAST_LOGIN_ACCOUNT'
const LOCAL_NOTICE_READED_LIST = 'LOCAL_NOTICE_READED_LIST'
let storage = new Storage()

export function getAccounts() {
    return storage.get(LOCAL_ACCOUNTS_KEY).value || []
}

/**
 * @param { {account: string password: string}[] } data
 */
export function setAccounts(data) {
    return storage.set(LOCAL_ACCOUNTS_KEY, data)
}

export function getLocalAppConfig() {
    return storage.get(LOCAL_APP_CONFIG).value || {}
}

export function setLocalAppConfig(data) {
    return storage.set(LOCAL_APP_CONFIG, data)
}

/* 保存用户登录/注册成功后后台返回的数据到本地 */
export function setLocalAccountData(data) {
    return storage.set(LOCAL_ACCOUNT_DATA_KEY, data)
}

export function getLocalAccountData() {
    return storage.get(LOCAL_ACCOUNT_DATA_KEY).value || {}
}

export function getLastLoginAccount() {
    return storage.get(LOCAL_LAST_LOGIN_ACCOUNT).value || {}
}
/** @param { { account: string password: string } } data */
export function setLastLoginAccount(data) {
    return storage.set(LOCAL_LAST_LOGIN_ACCOUNT, data)
}


// 存储微信公众号APPID对应的openID
const LOCAL_WECHAT_OPENIDS_KEY = 'LOCAL_WECHAT_OPENID'
export function getLocalWeChatOpenids() {
    return storage.get(LOCAL_WECHAT_OPENIDS_KEY).value || []
}

/**
 * @param {{ code: string }} data  */
export function setLocalWeChatOpenids(data) {
    return storage.set(LOCAL_WECHAT_OPENIDS_KEY, data)
}


export function getNoticeReadedList() {
    return storage.get(LOCAL_NOTICE_READED_LIST).value || {}
}
/**
 * @param { {account: string id: number}[] } data
 */
export function setNoticeReadedList(data) {
    return storage.set(LOCAL_NOTICE_READED_LIST, data)
}


export default storage
